import { createServiceApiClient } from "../lib/apiClient";

//--- base of service-requests ---//
const api = createServiceApiClient();

//////////////////////////////////////////////////////
//-------------------- ACTIVITY --------------------//
//////////////////////////////////////////////////////

//--- fetch activities ---//
export const fetchActivities = () => api.get(`/activities/`);

//--- fetch activity ---//
export const fetchActivity = ({ queryKey }) => {
  const activityId = queryKey[1];
  return api.get(`/activity/${activityId}`);
};

//--- post activity ---//
export const postActivity = (activity) => api.post(`/activity/`, activity);

//--- put activity ---//
export const putActivity = ({ activityId, ...activity }) =>
  api.put(`/activity/${activityId}`, activity);

//--- delete activity ---//

//////////////////////////////////////////////////////
//-------------------- MATERIAL --------------------//
//////////////////////////////////////////////////////

//--- fetch materials ---//
export const fetchMaterials = () => api.get(`/materials/`);

//--- fetch material ---//
export const fetchMaterial = ({ queryKey }) => {
  const materialId = queryKey[1];
  return api.get(`/material/${materialId}`);
};

//--- post material ---//
export const postMaterial = (material) => api.post(`/material/`, material);

//--- put material ---//
export const putMaterial = ({ materialId, ...material }) =>
  api.put(`/material/${materialId}`, material);

//--- delete material ---//

/////////////////////////////////////////////////////
//-------------------- SERVICE --------------------//
/////////////////////////////////////////////////////
//--- fetch services ---//
export const fetchServices = () => api.get(`/services/`);

//--- fetch service ---//
export const fetchService = ({ queryKey }) => {
  const serviceId = queryKey[1];
  return api.get(`/service/${serviceId}`);
};

//--- create service ---//
export const postService = (service) => api.post(`/service/`, service);

//--- put service ---//
export const putService = ({ serviceId, ...service }) =>
  api.put(`/service/${serviceId}`, service);

//--- delete service ---//

/////////////////////////////////////////////////////
//-------------------- SERVICE --------------------//
/////////////////////////////////////////////////////
//--- fetch servicegroups ---//
export const fetchServiceGroups = () => api.get(`/servicegroups/`);

//--- fetch servicegroup ---//
export const fetchServiceGroup = ({ queryKey }) => {
  const serviceGroupId = queryKey[1];
  return api.get(`/servicegroup/${serviceGroupId}/`);
};

//--- post servicegroup ---//
export const postServiceGroup = (serviceGroup) =>
  api.post(`/servicegroup/`, serviceGroup);

//--- put servicegroup ---//
export const putServiceGroup = ({ serviceGroupId, ...serviceGroup }) =>
  api.put(`/servicegroup/${serviceGroupId}/`, serviceGroup);

//--- delete servicegroup ---//
